import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import DashboardOverview from './DashboardOverview';
import ProductsManagement from './ProductsManagement';
import InventoryManagement from './InventoryManagement';
import OrdersManagement from './OrdersManagement';
import MessagesManagement from './MessagesManagement';
import StockAlerts from './StockAlerts';
import Analytics from './Analytics';

const AdminDashboard = ({ isLoggedIn, onLogout }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/admin');
    }
  }, [isLoggedIn, navigate]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex" data-testid="admin-dashboard">
      <AdminSidebar onLogout={onLogout} />
      
      <div className="flex-1 ml-64">
        <main className="p-8">
          <Routes>
            <Route path="/" element={<DashboardOverview />} />
            <Route path="/products" element={<ProductsManagement />} />
            <Route path="/inventory" element={<InventoryManagement />} />
            <Route path="/orders" element={<OrdersManagement />} />
            <Route path="/messages" element={<MessagesManagement />} />
            <Route path="/alerts" element={<StockAlerts />} />
            <Route path="/analytics" element={<Analytics />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;